import { useState, useEffect, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";
import DetailPair from "../UI/DetailPair";
import { toTitleCase } from "../../util/toTitleCase";
import { AuthContext } from "../../context/auth-context";
import { fetchTollById, fetchtollById } from "../../api/fetch";

export default function TollInfo() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const { user } = useContext(AuthContext);

  const [toll, setToll] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchTollById(user, id)
      .then((data) => {
        setToll(data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  if (!id)
    return (
      <div className="w-full h-full p-8 rounded-lg bg-stone-900">
        <p className="text-stone-400">Toll ID Not Provided!</p>
      </div>
    );

  if (!loading && !toll)
    return (
      <div className="w-full h-full p-8 rounded-lg bg-stone-900">
        <p className="text-stone-400">Toll Record Not Found!</p>
      </div>
    );
  return (
    <div className="container">
      <p className="text-lg font-semibold text-white">Toll Details</p>
      <div className="my-8">
        {loading ? (
          <LoadingSpinnerWrapper />
        ) : (
          <div className="grid gap-8">
            <div className="grid gap-4 text-sm md:grid-cols-3 md:grid">
              <DetailPair label="Toll ID" value={toll.id} />
              <DetailPair label="Vehicle ID" value={toll.vehicle.id} />
              <DetailPair
                label="Reported At"
                value={toTitleCase(toll["Reported At"])}
              />
              <DetailPair
                label="Vehicle"
                value={
                  toll.vehicle.make +
                  " " +
                  toll.vehicle.model +
                  " " +
                  toll.vehicle.year
                }
              />
              <DetailPair label="Tolled At" value={toll["Tolled At"]} />
              <DetailPair label="Amount" value={toll.Amount} />
              <DetailPair
                label="Description"
                value={toTitleCase(toll.Description)}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
